import React from 'react';
import PanelColorSection from '../PanelColorSection';
export default function ColorFill(_a) {
    var color = _a.color, wordBreak = _a.wordBreak;
    return (React.createElement(PanelColorSection, { colors: [color], label: "Colour", wordBreak: wordBreak }));
}
